import { createContext, useState, ReactNode } from 'react'

import { NotificationContextType } from '../types/context.types'
import { FundingNotification } from '../types/notification.types'

export const NotificationsContext = createContext<Partial<NotificationContextType>>({})

const fundingsNotificationsInitialState: Array<FundingNotification> = []

const Provider = ({ children }: { children: ReactNode }) => {
  const [newNotificationType, setNewNotificationType] = useState<string>('')
  const [showNewNotification, setShowNewNotification] = useState<boolean>(() => {
    if (typeof window !== 'undefined') {
      const storedValue = window.sessionStorage.getItem('showNewNotification')
      return storedValue ? storedValue === 'true' : false
    }
    return false
  })
  const [fundingsNotifications, setFundingsNotifications] = useState<Array<FundingNotification>>(() => {
    if (typeof window !== 'undefined') {
      const storedFundingsNotificationsData = window.localStorage.getItem('fundingsNotifications')
      return storedFundingsNotificationsData ? JSON.parse(storedFundingsNotificationsData) : fundingsNotificationsInitialState
    }
    return fundingsNotificationsInitialState
  })

  const value: NotificationContextType = {
    newNotificationType,
    showNewNotification,
    fundingsNotifications,
    updateNewNotificationStatus: (newNotificationStatus?: boolean, notificationType?: string) => {
      if (typeof window !== 'undefined' && typeof newNotificationStatus !== 'undefined') {
        setShowNewNotification(newNotificationStatus)
        window.sessionStorage.setItem('showNewNotification', String(newNotificationStatus))

        if (notificationType) setNewNotificationType(notificationType)
        return true
      } else if (typeof window !== 'undefined' && typeof newNotificationStatus === 'undefined') {
        setShowNewNotification(false)
        window.sessionStorage.removeItem('showNewNotification')

        if (typeof notificationType === 'undefined') setNewNotificationType('')
        return true
      }

      return false
    },
    updateFundingsNotificationsData: (fundingNotificationsDataToSet: Array<FundingNotification>) => {
      if (fundingNotificationsDataToSet.length === 0) {
        setFundingsNotifications([])
        const Window = window as Window
        Window.sessionStorage.removeItem('fundingsNotifications')
        return
      }

      fundingNotificationsDataToSet.sort((thisFundingNotification: FundingNotification, nextFundingNotification: FundingNotification) => {
        return Date.parse(String(nextFundingNotification.createdAt)) - Date.parse(String(thisFundingNotification.createdAt))
      })
      setFundingsNotifications(fundingNotificationsDataToSet)
      if (typeof window !== 'undefined') window.localStorage.setItem('fundingsNotifications', JSON.stringify(fundingNotificationsDataToSet))
    }
  }

  return <NotificationsContext.Provider value={value}>{children}</NotificationsContext.Provider>
}

const NotificationsContextProvider = {
  Provider,
  Consumer: NotificationsContext.Consumer
}

export default NotificationsContextProvider
